
import FormInput from '~/components/form/form__input/form__input.vue'
import { ParamCustomerTypeSlugMixin, RoutesMixin, TranslationMixin } from '~/mixins'

export default {
  nuxtI18n: {
    paths: {
      de: '/:customerTypeSlug/registrierung',
      en: '/:customerTypeSlug/registration'
    }
  },
  name: 'Registration',
  layout: context => context.store.getters['store__app/getCurrentLayoutForDevice'],
  components: { FormInput },
  mixins: [ParamCustomerTypeSlugMixin, RoutesMixin, TranslationMixin],
  data() {
    return {
      inputs: {
        firstname: { key: 'firstname', store: 'registration' },
        lastname: { key: 'lastname', store: 'registration' },
        street: { key: 'street', store: 'registration' },
        housenumber: { key: 'housenumber', store: 'registration' },
        zipcode: { key: 'zipcode', store: 'registration' },
        city: { key: 'city', store: 'registration' },
        email: { key: 'email', store: 'registration' }
      },
      isValid: true
    }
  },
  computed: {
    isPending() {
      return this.$store.getters['store__api__registration/isPending']
    },
    email() {
      return this.$store.getters['store__app__registration/getInputValue']('email')
    }
  },
  methods: {
    checkValidity(inputElement) {
      this.isValid = this.$refs.form.checkValidity()
    },
    postRegistration() {
      if (!this.checkValidity) {
        return false
      }
      this.$store.dispatch('store__api__registration/register')
    }
  },
  mounted() {
    this.$store.dispatch('store__app/setPageHeadline', this.$t('pages.registration.headline'))
  }
}
